import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { useAppContext } from '../../../../common/context';
import { callApi, getUrlencoded } from '../../../../common/utils/salesforce';
import { useNavigate } from 'react-router-dom';
import { SectionWrapper } from '../../../../theme/layouts/MainLayout';
import LeftContent from './LeftContent';
import ContactForm from './ContactForm';
import { techBlack } from '../../../../common/utils/constant';
import "./heroSection.scss";
import AppImage from '../../../../common/features/image';

const initValue = {
  Message__c: '',
  Role__c: '',
  first_name: '',
  last_name: '',
  brand: '',
  email: ''
}

function HeroSection({ data }) {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [values, setValue] = useState(initValue);
  const [validated, setValidated] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const { environment } = useAppContext();

  const submitHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    setError(null);
    setValidated(true);
    try {
    if (form.checkValidity() && isValid) {
      for (let key in values) {
        if (values.hasOwnProperty(key)) {
          values[key] = values[key].trim();
        }
      }
      const urlencoded = getUrlencoded(values);
      callApi(urlencoded, environment)
        .then(response => {

          if (response) {
            setError(null);
            setValidated(false);
            navigate("/thank-you", { state: {message: data.thankMessage, flag: true} }) 
          }
          return response;
        })

        .catch(error => {
          console.error('Submission failed:', error);
        });
    } else {
      setError('One or more fields have an error. Please check and try again.');
    }
  } catch (error) {
    console.error('Unexpected error during form submission:', error);
    setError('An unexpected error occurred. Please try again later.'); 
  }
  }

  return (
    <SectionWrapper bg={techBlack}>
      <section className='header-wrapper-section'>
        <Row>
          <Col md={6} sm={12} className='text-white'>
            <LeftContent data={data.hero} />
          </Col>
          <Col md={6} sm={12} >
            <div className='right-form-container'>
            <ContactForm
              values={values}
              setValue={setValue}
              error={error}
              isValid={isValid}
              setIsValid={setIsValid}
              validated={validated}
              submitHandler={submitHandler}
            />
            </div>
          </Col>
        </Row>
      </section>
    </SectionWrapper>
  )
}

export default HeroSection;

export const CtaBrand = ({iconFile, page}) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
    <div className={`${page === 'audience' ? 'audience-cta-link' : 'cta-link'}`}>
         <span onClick={() => scrollToTop()} className="cursor-pointer"> <span>Back to top</span>
          <AppImage src={iconFile} alt="Up Icon" title="Up Icon" width={24} height={24} />
          </span>
         
        </div>
    </>
  )
}
